import {Action, applyMiddleware, compose, createStore} from "redux";
import thunkMiddleware, {ThunkAction} from "redux-thunk";
import rootReducer from "./reducers";

type RootReducerType = typeof rootReducer; //(globalState: AppStateType) => AppStateType
export type AppStateType = ReturnType<RootReducerType>; //тип возвращаемого значения

//объект T является парой ключ-значение(U) - возвращаем значение(U)
type PropertiesTypes<T> = T extends {[key: string]: infer U} ? U : never
//если объект T является парой ключ-значение, у которого значение - функция, принимающая любое кол-во аргументов
//и возвращающая any, то возвращаем значение, удалив ключ через вызов ReturnType<PropertiesTypes<T>>
export type InferActionTypes_<T extends {[key: string]: (...args: any[])=>any}> = ReturnType<PropertiesTypes<T>>

export type InferActionTypes<T> = T extends {[key: string]: (...args: any[])=> infer U} ? U : never

export type BaseThunkType<A extends Action, R = Promise<void>> = ThunkAction<R, AppStateType, unknown, A>

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));
//let store = createStore(reducers, applyMiddleware(thunkMiddleware));

// @ts-ignore
window.__store__ = store;

export default store;
